export default "__VITE_ASSET__B6JuXRPf__"